import { request } from './client';

/**
 * Tenant-scoped user CRUD over the `user_master` collection. All paths
 * run under the calling tenant's X-Tenant-Id header (set by the axios
 * interceptor) so a TENANT_ADMIN can only see / mutate users inside
 * their own tenantId — the backend rejects cross-tenant access.
 */

export type TenantUserRole = 'TENANT_ADMIN' | 'CLINIC_USER' | 'TENANT_USER';

export interface TenantUser {
  id: string;
  username: string;
  email?: string | null;
  mobile?: string | null;
  fullName?: string | null;
  role: TenantUserRole | string;
  tenantId: string;
  status?: string;
  active: boolean;
  enabled: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface TenantUserUpsertBody {
  username?: string;
  password?: string;
  role?: TenantUserRole;
  email?: string;
  mobile?: string;
  fullName?: string;
  status?: string;
  active?: boolean;
  enabled?: boolean;
}

export const tenantUsers = {
  list: () =>
    request<TenantUser[]>({ url: '/api/abdm/tenant/users', method: 'GET' }),
  create: (body: TenantUserUpsertBody) =>
    request<TenantUser>({ url: '/api/abdm/tenant/users', method: 'POST', data: body }),
  update: (id: string, body: TenantUserUpsertBody) =>
    request<TenantUser>({
      url: `/api/abdm/tenant/users/${encodeURIComponent(id)}`,
      method: 'PATCH',
      data: body,
    }),
  deactivate: (id: string) =>
    request<void>({
      url: `/api/abdm/tenant/users/${encodeURIComponent(id)}`,
      method: 'DELETE',
    }),
};
